import { FEED_POST_DETAIL, GROUP_ROLE_ACCESS } from '@/constant/QueryKeyName';
import { ROLE_ACCESS, TRoleAccess } from '@/constant/storage';
import { getMineRoleOfFolder } from 'apis/tms/share';
import { checkIsUserJoined } from 'common/checkRoleUser';
import { useContext, useState } from 'react';
import { useQuery, useQueryClient } from 'react-query';
import AuthContext from 'state/auth/AuthContext';

export default function usePostGroupRole({
  groupId,
  postId,
}: {
  groupId?: string;
  postId: string;
}) {
  const { isLoggedIn } = useContext(AuthContext);

  const [userRole, setUserRole] = useState<TRoleAccess>(ROLE_ACCESS.Revoked);

  const queryClient = useQueryClient();

  const queryReturn = useQuery(
    [GROUP_ROLE_ACCESS, groupId, 'button_only'],
    () =>
      getMineRoleOfFolder({
        folderId: groupId as string,
      }),
    {
      onSettled(data) {
        if (checkIsUserJoined(data as ROLE_ACCESS)) {
          queryClient.refetchQueries([FEED_POST_DETAIL, postId], {
            active: true,
          });
        }
        setUserRole(data || ROLE_ACCESS.Revoked);
      },
      refetchOnMount: true,
      enabled: isLoggedIn() && !!groupId,
      staleTime: 3 * 60 * 1000,
      cacheTime: 5 * 60 * 1000,
    }
  );

  return { ...queryReturn, data: userRole };
}
